<div class="container mt-5">
    <div class="d-flex align-items-center">
        <h2>Work for:</h2>
        <select class="form-control ml-3" style="width: fit-content" [(ngModel)]="selectedCourseOrActivityCode"
            (change)="changeCourse(selectedCourseOrActivityCode)">
            <option *ngFor="let courseOrActivity of courseOrActivitys" [ngValue]="courseOrActivity.isCourse ? courseOrActivity.Course.Code : courseOrActivity.ActivityName">
                {{ courseOrActivity.isCourse ? courseOrActivity.Course.Description : courseOrActivity.ActivityName }}
            </option>
        </select>
    </div>
    <div class="row align-items-center justify-content-center" *ngIf="selectedCourseOrActivityCode !== 'DaisyChain' && selectedCourseOrActivityCode !== 'KadyChain' ">
        <div class="missing-artifact-text"
            *ngIf="selectedCourseArtifacts === null || !isLoading && selectedCourseArtifacts.length === 0">
            No work to display right now. Check back soon!
        </div>
        <div class="container">
            <div class="artifact-grid">
                <div *ngFor="let artifact of selectedCourseArtifacts">
                    <app-artifact-display-speech-rec *ngIf="isInternalUser && artifact.SpeechRecPromptMetadata" [artifact]="artifact"></app-artifact-display-speech-rec>
                    <app-artifact-display *ngIf="!isInternalUser || !artifact.SpeechRecPromptMetadata" [artifact]="artifact"></app-artifact-display>
                </div>
            </div>
        </div>
        <div class="missing-artifact-text" *ngIf="isLoading"><i class="fal fa-spinner fa-spin fa-2x m-4"></i></div>
        <button *ngIf="!isLoading && !(selectedCourseArtifacts === null) && (selectedCourseArtifacts.length > 0)" 
                class="btn btn-primary mt-4" (click)="loadArtifacts()" [disabled]="allArtifactsLoaded">
            Load More
        </button>
    </div>
    <app-daisychain-conversations-viewer *ngIf="selectedCourseOrActivityCode === 'DaisyChain' "
        [studentID]="studentID" [defaultCourseCode] ="defaultCourseCode"></app-daisychain-conversations-viewer>
    <app-kadychain-conversations-viewer *ngIf="selectedCourseOrActivityCode === 'KadyChain' "
    [studentID]="studentID"></app-kadychain-conversations-viewer>
</div>